/* eslint-disable max-params */
import XHR from '../utils/xhr';
import ConfigStore from '../stores/Config';

const isFbqLoaded = () => {
  return window.fbq && window.fbq.loaded;
};

export const trackSingle = ({ custom, pixelId, event, data, vnextFbPixelId }) => {
  // https://jira.godaddy.com/browse/BEAR-675
  const isValidParams = isFbqLoaded() && pixelId && event && vnextFbPixelId;
  const trackType = custom ? 'trackSingleCustom' : 'trackSingle';

  if (!isValidParams) {
    return false;
  }

  window.fbq(trackType, pixelId, event, data);
};

export const trackPixel = (eventName, data = {}) => {
  const { tracks_fbe_pixel: tracksFbePixel } = ConfigStore.getState();
  const currentTimestamp = +new Date();
  const eventId = `${eventName}_${currentTimestamp}`;

  if (isFbqLoaded()) {
    window.fbq('track', eventName, data, { eventID: eventId });
  }

  if (tracksFbePixel) {
    data.eventId = eventId;

    XHR.postRequest(`${ConfigStore.getApiBaseUrl()}/facebook/events`, {
      data: {
        event: eventName,
        ...data,
        source_url: window.location.href
      }
    });
  }
};
